import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  scoreScaleHint: {
    defaultMessage:
      'This rule compares total points, not a percentage. An assessment’s maximum depends on its questions, so the same value means different things across assessments.',
    id: `app.containers.WorkflowEditor.components.Rules.Condition.AssessmentFormScoreResult.scoreScaleHint`,
  },
  scoreInputPlaceholder: {
    defaultMessage: 'Score in points',
    id: `app.containers.WorkflowEditor.components.Rules.Condition.AssessmentFormScoreResult.scoreInputPlaceholder`,
  },
});
